import styled from "styled-components";
import { Props } from "./index";

const PublicProfileContainer = styled.div<Props>`
  //display: flex;
`;
export { PublicProfileContainer };
